// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

export function getSortedCertificationDocuments(documents) {
  return [...documents].sort((a, b) => {
    const aField = a.title ?? a.filename;
    const bField = b.title ?? b.filename;
    return aField.localeCompare(bField, 'en', { numeric: true });
  });
}
